const env = process.env;

const Config = {
    KEYS: {
        PARSED_KEY: env.REACT_APP_PARSED_KEY,
        IV_KEY: env.REACT_APP_IV_KEY,
        MAP_KEY: env.REACT_APP_MAP_KEY,
        VAPID_KEY: env.REACT_APP_VAPIDKEY,
        PAYMENT_KEY: env.REACT_APP_PAYMENT_KEY,
    },
    FIREBASE: {
        API_KEY: env.REACT_APP_FIREBASE_API_KEY,
        AUTH_DOMAIN: env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        PROJECTID: env.REACT_APP_FIREBASE_PROJECTID,
        STORAGE_BUCKET: env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        MESSAGING_SENDERID: env.REACT_APP_FIREBASE_MESSAGING_SENDERID,
        APPID: env.REACT_APP_FIREBASE_APPID,
    },
    URL: {
        BACKEND_URL: env.REACT_APP_BACKEND_URL,
    },
    // "geometry" added for the delivery/pickup map picker's live hub-distance
    // readout (google.maps.geometry.spherical.computeDistanceBetween) - same
    // loader/key as the Hub form's LocationPicker, so this is the one place
    // that needs to change for every consumer of useJsApiLoader in this app.
    GOOGLE_MAPS_LIBRARIES: ["places", "geometry"],
    PAGE_SIZE: 10,
};

export default Config;
